import * as React from 'react';
import { useState, useEffect } from 'react';
import styled from 'styled-components';

import t from './locales';
import { colors } from '../styles/variables';

import { getImage } from '../utils/pathHelper';
import checkIcon from './images/line_icon/check_40px_blue.svg';

import Button from '../Shared/Button';
import { ITEM_ADDED_TO_CART } from './events';

interface IAlertProps {
}

const BackDrop = styled.div`
  display: none;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5);
  z-index: 10;
  &.active {
    display: flex;
  }
`;

const Alert = styled.div`
  background-color: ${colors.white};
  border-radius: 4px;
  padding: 16px;
  width: 90%;
  max-width: 350px;
  margin: 0 auto;
  transform: translate3d(0,-30px,0);
  opacity: 0;
  transition: all 0.5s ease-in-out;
  &.active {
    transform: translate3d(0,0,0);
    opacity: 1.0;
  }
`;

const CheckIcon = styled.img`
  width: 48px;
  display: block;
  margin: 0 auto;
`;

const Message = styled.p`
  font-size: 14px;
  font-weight: bold;
  text-align: center;
`;

const ActionFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: stretch;
  a {
    flex: 1;
    margin-right: 0.5rem;
  }
  a:last-of-type {
    margin-right: 0;
  }
`;


const AlertSuccess: React.FC<IAlertProps> = (props) => {
  const shouldScrollToTop = new CustomEvent('shouldScrollToTop')

  const [isActive, setActive] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const showAlert = (event: CustomEvent) => {
    setActive(true);
  }

  useEffect(() => {
    document.addEventListener(ITEM_ADDED_TO_CART, showAlert);
    return () => {
      document.removeEventListener(ITEM_ADDED_TO_CART, showAlert);
    }
  }, []);

  const handleClose = (event: React.MouseEvent) => {
    event.preventDefault();
    setActive(false);
    window.dispatchEvent(shouldScrollToTop)
  }

  return (
    <BackDrop className={isActive && 'active'}>
      <Alert className={isActive && 'active'}>
        <CheckIcon src={getImage(checkIcon)} style={{ marginTop: 24 }} />
        <Message style={{ marginTop: 24, marginBottom: 40 }}>
          {t.itemIsAddedToCart()}
        </Message>
        <ActionFooter>
          <Button href="#" onClick={handleClose}>{t.close()}</Button>
          <Button
            href="/snow/me/shopping_cart"
            onClick={() => { setLoading(true); }}
            isLoading={isLoading}
            primary
          >
            {t.seeCart()}
          </Button>
        </ActionFooter>
      </Alert>
    </BackDrop>
  );
}

export default AlertSuccess;
